// DEPENDENCIES
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useFormik } from "formik";
// COMPONENTS
import Select from 'react-select';
import Flatpickr from "react-flatpickr";
import { Divider } from '@material-ui/core'
import { Link, useParams } from 'react-router-dom';
import { FilePond, registerPlugin } from "react-filepond";
import BlockUi from 'react-block-ui';
import MUIDataTable from "mui-datatables";
import moment from 'moment';
import { ModalProgressBar } from "../../../../_metronic/_partials/controls";
import { Modal, Button, InputGroup, FormControl, Container, Row, Col, Form } from "react-bootstrap";
// CUSTOM COMPONENTS
import * as alert from '../../../../redux/alertSnackBarRedux';
import * as confirmModal from '../../../../redux/confirmModalRedux';
// SERVICES AND HELPERS
import DailyLogFormValidator from '../../../../helpers/validators/DailyLogFormValidator';
import DailyLogFormLineItemValidaor from '../../../../helpers/validators/DailyLogLineItemValidator';
import * as jobFormService from '../../../../services/service/jobFormService';
import * as dailyLogFormService from '../../../../services/form/dailyLogFormService';
import * as helper from "../../../../helpers/helper";
//STYLES AND ASSETS

const initialState = {
    id: 0,
    projectLocationId: null,
    date: new Date(),
    description: '',
    formLead: '',
    dailyLogLineItems: []
}

const lineItemInitialState = {
    id: 0,
    dateTime: '',
    entry: '',
}

const DailyLogForm = (props) => {
    const iframeRef = useRef();
    const { showAlert, showConfirmModal, hideConfirmModal, setProcessing, history } = props;
    const { jobFormId, edit } = useParams();
    const [loading, setLoading] = useState(false);
    const [dailyLog, setDailyLog] = useState(initialState);
    const [isEditLineItem, setIsEditLineItem] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [locationOptions, setLocationOptions] = useState([]);
    const [switchMode, setSwitchMode] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [dailyLogToEdit, setDailyLogToEdit] = useState({ ...lineItemInitialState });
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [jobForm, setJobForm] = useState({
        id: 0,
        jobFormId: 0,
        jobId: 0,
        formLeadId: 0,
        actualAssignedDate: new Date(),
        client: "",
        projectNumber: "",
        projectType: "",
        name: "Daily Log Form",
        submittedById: 0,
        dailyLogForm: initialState,
    });

    useEffect(() => {
        if (edit == 'false') {
            setSwitchMode(true)
            getReport(jobFormId)
        }
        else {
            fetchJobLocations().then(res => {
                fetchDailyLogForm(res);
            });
        }
    }, [])

    const fetchJobLocations = () => jobFormService.getProposalProjectLocationsByJobFormId(jobFormId).then(res => {
        setLocationOptions(res);
        return res;
    });

    const fetchDailyLogForm = (projectLocations) => {
        setLoading(true);
        dailyLogFormService.getDailyLogFormByJobFormId(jobFormId).then(res => {
            if (res.dailyLogForm.projectLocationId) {
                setSelectedLocation(projectLocations.find(x => x.value == res.dailyLogForm.projectLocationId));
            }
            setIsReadOnly(res.submittedById);
            setJobForm(res);
            setDailyLog(res.dailyLogForm);
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        }).finally(() => setLoading(false));
    }

    const getReport = (id) => {
        if (id) {
            dailyLogFormService.getReportPdf(id).then(res => {
                iframeRef.current.src = "data:application/pdf;base64," + res;
            }).catch(ex => {
            })
        }
    }

    const editLineItem = (id) => {
        setProcessing();
        setIsModalOpen(true);
        setIsEditLineItem(true)
        let temp = [...dailyLog.dailyLogLineItems];
        setDailyLogToEdit({ ...temp.find(x => x.id == id) })
    }

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 1,
                print: false,
                download: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {!isReadOnly && <><button
                                type="button"
                                href="#"
                                className="btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5"
                                onClick={() => showConfirmModal({
                                    title: "Delete Line Item",
                                    text: "Are you sure you want to delete this line item?",
                                    rightBtnText: "Confirm",
                                    btnAction: () => removeLineItem(dailyLog.dailyLogLineItems[dataIndex].id)
                                })}
                            >
                                Delete
                            </button>
                            &nbsp;

                                <button
                                    type="button"
                                    href="#"
                                    className="btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5"
                                    onClick={() => editLineItem(dailyLog.dailyLogLineItems[dataIndex].id)}
                                >
                                    Edit
                                </button>
                            </>}
                        </>
                    );
                }
            },
        },
        {
            name: "dateTime",
            label: "Time",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {moment(dailyLog.dailyLogLineItems[dataIndex].dateTime).format("MM/DD/YYYY HH:mm")}
                        </>
                    );
                }
            }
        },
        {
            name: "entry",
            label: "Entry",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        }
    ];

    const removeLineItem = (id) => {
        setProcessing();
        dailyLogFormService.deleteLineItem(id).then(res => {
            let temp = [...dailyLog.dailyLogLineItems];
            temp.splice(temp.findIndex(x => x.id === id), 1);
            setDailyLog({ ...dailyLog, dailyLogLineItems: temp });
            showAlert({ message: res.message, variant: 'success' })
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => {
            hideConfirmModal();
        })
    }

    const handleModalClose = () => {
        setIsModalOpen(false);
        setIsEditLineItem(false);
        setDailyLogToEdit({});
        formik_lineItem.resetForm();
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: dailyLog,
        validationSchema: DailyLogFormValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            setLoading(true);
            saveForm(values).finally(() => {
                setLoading(false);
                setSubmitting(false);
            });
        }
    });

    const formik_lineItem = useFormik({
        enableReinitialize: true,
        initialValues: dailyLogToEdit,
        validationSchema: DailyLogFormLineItemValidaor,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            setLoading(true);
            dailyLogFormService.saveLineItem({ ...values, dailyLogFormId: dailyLog.id, formLeadId: jobForm.dailyLogForm.formLeadId ? jobForm.dailyLogForm.formLeadId : jobForm.formLeadId }).then(res => {
                let temp = [...dailyLog.dailyLogLineItems];
                if (isEditLineItem) {
                    temp[temp.findIndex(x => x.id == values.id)] = { ...values, id: res.id };
                }
                else {
                    temp.push({ ...values, id: res.id });
                }
                setDailyLog({ ...dailyLog, dailyLogLineItems: temp });
                showAlert({ message: res.message, variant: 'success' });
            }).catch(ex => {
                showAlert({ message: ex.message, variant: 'error' })
            }).finally(() => {
                setLoading(false);
                setSubmitting(false);
                handleModalClose();
            });
        }
    });

    const saveForm = (values) => {
        return dailyLogFormService.save({ ...values, formLeadId: jobForm.dailyLogForm.formLeadId ? jobForm.dailyLogForm.formLeadId : jobForm.formLeadId }).then(res => {
            showAlert({ message: res.message, variant: 'success' })
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        })
    }

    const submitForm = () => {
        formik.validateForm().then(res => {
            if (Object.keys(res).length > 0) {
                let err = "";
                for (const property in res) {
                    err += res[property] + ". ";
                }

                showAlert({ message: err + " Please save before submitting the form", variant: 'error' });
                return;
            }

            saveForm(formik.values).then(res => {
                jobFormService.submitForm(jobForm.id).then(res => {
                    showAlert({ message: res.message, variant: 'success' });
                    history.push("/services/manage-job/forms/" + jobForm.jobId);
                }).catch(ex => {
                    showAlert({ message: ex.message, variant: 'error' })
                })
            }).catch(ex => {
                showAlert({ message: ex.message, variant: 'error' })
            })
        })
    }

    return (
        <>
            {
                switchMode ?
                    (<iframe ref={iframeRef} style={{ height: '100%', width: '100%' }} title="description"></iframe>)
                    :
                    (
                        <>
                            <div className="card card-custom card-stretch">
                                <Modal centered size="lg" show={isModalOpen} onHide={handleModalClose}>
                                    <form className="card card-custom" onSubmit={formik_lineItem.handleSubmit}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>{isEditLineItem ? 'Edit' : 'Add'} Daily Log Entry</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <div className="form">
                                                <div className="form-group row">
                                                    <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                        Time
                                                    </label>
                                                    <div className="col-lg-9 col-xl-9">
                                                        <Flatpickr
                                                            placeholder="MM/DD/YYYY HH:MM"
                                                            options={{
                                                                enableTime: true,
                                                                dateFormat: "m/d/Y H:i",
                                                                time_24hr: true,
                                                            }}
                                                            value={formik_lineItem.getFieldProps("dateTime").value}
                                                            onChange={date => {
                                                                formik_lineItem.setFieldValue("dateTime", moment(date[0]).format("MM/DD/YYYY HH:mm"));
                                                            }}
                                                            className={`form-control form-control-lg form-control-solid ${helper.getInputClasses(formik_lineItem, "dateTime")}`}
                                                        />
                                                        {formik_lineItem.touched.dateTime && formik_lineItem.errors.dateTime ? (
                                                            <div className="invalid-feedback display-block">
                                                                {formik_lineItem.errors.dateTime}
                                                            </div>
                                                        ) : null}

                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                        Entry
                                                    </label>
                                                    <div className="col-lg-9 col-xl-9">
                                                        <Form.Control as="textarea" rows="5"
                                                            placeholder="Enter Entry"
                                                            className={`form-control form-control-lg form-control-solid`}
                                                            name="entry"
                                                            {...formik_lineItem.getFieldProps("entry")}
                                                        />
                                                        {formik_lineItem.touched.entry && formik_lineItem.errors.entry ? (
                                                            <div className="invalid-feedback display-block">
                                                                {formik_lineItem.errors.entry}
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="secondary" onClick={handleModalClose}>
                                                Close
                                            </Button>
                                            <button
                                                type="submit"
                                                className="btn btn-success mr-2"
                                                disabled={
                                                    formik_lineItem.isSubmitting || (formik_lineItem.touched && !formik_lineItem.isValid)
                                                }
                                            >
                                                {isEditLineItem ? 'Save' : 'Add'}
                                                {formik_lineItem.isSubmitting}
                                            </button>
                                        </Modal.Footer>
                                    </form>
                                </Modal>
                                {loading && <ModalProgressBar />}
                                <div className="card-header py-3">
                                    <div className="card-title align-items-start flex-column">
                                        <h3 className="card-label font-weight-bolder text-dark">
                                            Daily Log - ({moment(jobForm.actualAssignedDate).format("MM/DD/YYYY")})
                                        </h3>
                                        <span className="text-muted font-weight-bold fz-xs mt-1">
                                            Please fill the form below
                                        </span>
                                    </div>

                                    <div className="card-toolbar">
                                        {!isReadOnly && <button
                                            type="submit"
                                            className={`btn btn-success mr-2`}
                                            disabled={
                                                formik.isSubmitting || (formik.touched && !formik.isValid)
                                            }
                                            onClick={() => submitForm()}
                                        >
                                            Submit Form
                                            {formik.isSubmitting}
                                        </button>}
                                        {/* <Link
                                            to={"/services/manage-job/forms/" + jobForm.jobId}
                                            className="btn btn-danger"
                                        >
                                            Cancel
                                        </Link> */}
                                        {
                                            <>
                                                <button
                                                    className={`btn btn-info mr-2`}
                                                    onClick={() => {
                                                        setSwitchMode(true);
                                                        getReport(jobForm ? jobForm.id : 0)
                                                    }}
                                                >
                                                    Print Form
                                                </button>

                                            </>
                                        }
                                    </div>
                                </div>
                                <div className="form">
                                    <form className="card card-custom" onSubmit={formik.handleSubmit}>
                                        <fieldset disabled={isReadOnly}>
                                            <div className="card-body">
                                                <Row>
                                                    <Col>
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                                AES Project#
                                                            </label>
                                                            <div className="col-xl-9">
                                                                <input
                                                                    readOnly
                                                                    type="text"
                                                                    placeholder="21-0003-01"
                                                                    className={`form-control form-control-lg form-control-solid`}
                                                                    name="name"
                                                                    value={jobForm.projectNumber}
                                                                />
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col>
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                                Client
                                                            </label>
                                                            <div className="col-xl-9">
                                                                <input
                                                                    readOnly
                                                                    type="text"
                                                                    placeholder="Primtek LLC"
                                                                    className={`form-control form-control-lg form-control-solid`}
                                                                    name="client"
                                                                    value={jobForm.client}
                                                                />
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col>
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                                Date
                                                            </label>
                                                            <div className="col-xl-9">
                                                                <input
                                                                    readOnly
                                                                    type="text"
                                                                    placeholder="08/09/2021"
                                                                    className={`form-control form-control-lg form-control-solid`}
                                                                    name="date"
                                                                    value={moment(dailyLog.date).format("MM/DD/YYYY")}
                                                                />
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                                Project Location
                                                            </label>
                                                            <div className="col-xl-9">
                                                                <Select
                                                                    value={selectedLocation}
                                                                    options={locationOptions}
                                                                    onChange={selectedOption => {
                                                                        selectedOption = selectedOption === null ? [] : selectedOption;
                                                                        setSelectedLocation(selectedOption);
                                                                        formik.setFieldValue("projectLocationId", selectedOption.value);
                                                                    }}
                                                                    className={`${helper.getInputClasses(formik, "projectLocationId")}`}
                                                                    name="projectTypeId"
                                                                    placeholder="Select Project Location"
                                                                />
                                                                {formik.touched.projectLocationId && formik.errors.projectLocationId ? (
                                                                    <div className="invalid-feedback">
                                                                        {formik.errors.projectLocationId}
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col>
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                                Type of Project
                                                            </label>
                                                            <div className="col-xl-9">
                                                                <input
                                                                    readOnly
                                                                    type="text"
                                                                    placeholder="Project Type"
                                                                    className={`form-control form-control-lg form-control-solid`}
                                                                    name="name"
                                                                    value={jobForm.projectType}
                                                                />
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                                Amount and Type of Material Being Abated
                                                            </label>
                                                            <div className="col-xl-9">
                                                                <Form.Control as="textarea" rows="5"
                                                                    placeholder="Start typing..."
                                                                    className={`form-control form-control-lg form-control-solid`}
                                                                    name="entry"
                                                                    {...formik.getFieldProps("description")}
                                                                />
                                                                {formik.touched.description && formik.errors.description ? (
                                                                    <div className="invalid-feedback">
                                                                        {formik.errors.description}
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <div className="d-flex justify-content-between">
                                                    <div className="d-flex">
                                                        <h5 className="mt-lg-10 mb-6 fz-md fw-700 c-primary">Log</h5>
                                                    </div>
                                                    {
                                                        !isReadOnly &&
                                                        <div className="d-flex align-items-center">
                                                            <button
                                                                type="button"
                                                                onClick={() => setIsModalOpen(true)}
                                                                className="btn btn-info mr-2 fit-content"

                                                            >
                                                                Add Log
                                                            </button>
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary mr-2 fit-content"
                                                                disabled={
                                                                    formik.isSubmitting || (formik.touched && !formik.isValid)
                                                                }
                                                            >
                                                                Save Form
                                                                {formik.isSubmitting}
                                                            </button>
                                                        </div>
                                                    }
                                                </div>
                                                <Divider />
                                                <MUIDataTable
                                                    data={dailyLog.dailyLogLineItems}
                                                    columns={columns}
                                                    options={{
                                                        selectableRows: 'none',
                                                    }}
                                                />
                                            </div>
                                        </fieldset>
                                    </form>
                                </div>
                            </div>
                        </>
                    )
            }
        </>


    )
}


export default connect(null, {
    ...alert.actions,
    ...confirmModal.actions
})(DailyLogForm);